"use strict";
/**
 * ACWR (Acute:Chronic Workload Ratio, Gabbett) — FORMULA CANONICA
 * (@leopart/calc).
 *
 * Estrazione 1:1 di `calculateACWR` (apps/backend/src/utils/generic.ts):
 * stesse finestre rolling [ref, ref-1, …], stessi arrotondamenti (acwr a 2
 * decimali, carichi all'intero), stessa guardia chronic ≤ 0 (PF04).
 * Qui però le date sono STRINGHE PURE YYYY-MM-DD (niente dayjs, zero deps):
 * l'aritmetica di calendario usa una util interna su epoch-UTC, esatta anche
 * attraverso i cambi DST — la risoluzione timezone del giorno logico resta
 * responsabilità del backend.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateACWR = calculateACWR;
exports.hasMinAcwrHistory = hasMinAcwrHistory;
const constants_1 = require("./constants");
const calendario_1 = require("./calendario");
/**
 * Calcola l'ACWR a partire da una mappa giornaliera di sRPE e una data di
 * riferimento (inclusa nella finestra).
 *
 * @param dailySrpeMap  - Mappa chiave=YYYY-MM-DD, valore=sRPE giornaliero totale
 * @param referenceDate - Data di riferimento YYYY-MM-DD (giorno logico)
 * @param acuteDays     - Giorni per il carico acuto (default: 7)
 * @param chronicDays   - Giorni per il carico cronico (default: 28)
 * @returns ACWR = acute / chronic (0 se chronic ≤ 0), acwr a 2 decimali,
 *          carichi arrotondati all'intero
 */
function calculateACWR(dailySrpeMap, referenceDate, acuteDays = constants_1.ACWR_ACUTE_DAYS, chronicDays = constants_1.ACWR_CHRONIC_DAYS) {
    var _a, _b;
    let acuteSum = 0;
    for (let i = 0; i < acuteDays; i++) {
        acuteSum += (_a = dailySrpeMap.get((0, calendario_1.sommaGiorni)(referenceDate, -i))) !== null && _a !== void 0 ? _a : 0;
    }
    const acuteLoad = acuteSum / acuteDays;
    let chronicSum = 0;
    for (let i = 0; i < chronicDays; i++) {
        chronicSum += (_b = dailySrpeMap.get((0, calendario_1.sommaGiorni)(referenceDate, -i))) !== null && _b !== void 0 ? _b : 0;
    }
    const chronicLoad = chronicSum / chronicDays;
    // PF04: guard per chronic <= 0 (include chronic negativo da dati corrotti)
    const acwr = chronicLoad > 0 ? acuteLoad / chronicLoad : 0;
    return {
        acwr: Math.round(acwr * 100) / 100,
        acuteLoad: Math.round(acuteLoad),
        chronicLoad: Math.round(chronicLoad),
    };
}
/**
 * True se, alla data di riferimento, il primo giorno con carico (>0) è
 * abbastanza lontano nel passato (span INCLUSIVO ≥ minDays) da rendere l'ACWR
 * interpretabile. Con mappa vuota (o soli zeri) ritorna false.
 * Semantica identica a `hasMinAcwrHistory` di effort-calculations (span =
 * diff giorni di calendario + 1).
 */
function hasMinAcwrHistory(dailySrpeMap, referenceDate, minDays = constants_1.ACWR_MIN_HISTORY_DAYS) {
    let oldest = null;
    for (const [day, value] of dailySrpeMap) {
        if (value > 0 && (!oldest || day < oldest))
            oldest = day;
    }
    if (!oldest)
        return false;
    return (0, calendario_1.aGiorniEpoch)(referenceDate) - (0, calendario_1.aGiorniEpoch)(oldest) + 1 >= minDays;
}
